import { render } from "./EnrollStep.vue?vue&type=template&id=63d6fb31&scoped=true"
import script from "./EnrollStep.vue?vue&type=script&lang=js"
export * from "./EnrollStep.vue?vue&type=script&lang=js"

import "./EnrollStep.vue?vue&type=style&index=0&id=63d6fb31&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d6fb31"]])

export default __exports__